<template>
<section id="section-about" class="section appear" data-stellar-background-ratio="0.4">
			<div class="container">
				<div class="row">
					<div class="col-md-12 align-center">
						<i class="fa fa-fire fa-3x mar-bot20 notransition animated fadeInRightNow animation103"></i>
						<p class="section-header notransition animated fadeInDownNow animation103">关于我</p>
						<p class="section-subheader notransition animated fadeInUpNow animation103">璞玉浑金&nbsp;&nbsp;研究生一枚</p>
					</div>
				</div>
				<div class="row mar-bot40 mar-top40">
					<div class="mainp col-md-4 align-center notransition animated fadeInDownNow animation53">
						<i class="fa fa-book fa-5x mar-bot20"></i>
						<h4 class="text-bold">博览群书</h4>
						<p>书中自有颜如玉<br> 枕上诗书闲处好，门前风景雨来佳
						</p>
					</div>
					<div class="mainp col-md-4 align-center notransition animated fadeInDownNow animation56">
						<i class="fa fa-leaf fa-5x mar-bot20"></i>
						<h4 class="text-bold">仁礼存心</h4>
						<p class="mainp">君子之交淡若水<br>宽以待人，严于律己
							<!-- <br> 礼不至不相为谋 -->
						</p>
					</div>
					<div class="mainp col-md-4 align-center notransition animated fadeInDownNow animation59">
						<i class="fa fa-road fa-5x mar-bot20"></i>
						<h4 class="text-bold">好学不厌</h4>
						<p>学不可以已<br>故不登高山，不知天之高也
						</p>
					</div>
				</div>
			</div>
		</section>
</template>

<style>

</style>

<script>
export default {
  name: 'About'
}
</script>